import { useTranslation } from 'react-i18next';
import { MoveDownRight, MoveRight, MoveUpRight } from 'lucide-react';
import styles from './TrendBadge.module.css';

/**
 * "GECEN DONEME GORE" ROZETI — yon oku + yuzde.
 *
 * RENK YONUN KENDISINE DEGIL ANLAMINA BAGLI. Reddedilen teklif ya da odeme
 * uyarisi hacminin ARTMASI yukari oktur ama KOTU habertir; `goodDirection`
 * bunu cagri yerinde soyler. Yesil/kirmizi otomatik olarak "yukari iyi"ye
 * baglansaydi ekran yoneticiye tersini soylerdi.
 *
 * `delta === null` -> HIC CIZILMEZ. Onceki donem sifirsa yuzde tanimsizdir
 * (bkz. lib/trend.ts); bos bir rozet ya da "%0" gostermek, kiyas yapilamadigi
 * bilgisini kaybettirirdi.
 *
 * Sayi kendi basina "gecen doneme gore" demiyor — bu baglami ekran okuyucuya
 * gorunmez bir metin tasiyor; gorsel olarak baglami cevresindeki kart veriyor.
 */

export type TrendBadgeProps = {
  /** Yuzde degisim (trendDelta ciktisi). null → rozet cizilmez. */
  delta: number | null;
  /**
   * Artis ne zaman IYI haber? Hacim/kazanc icin 'up' (varsayilan); reddedilen,
   * kacirilan ya da uyarilan gibi metriklerde 'down'.
   */
  goodDirection?: 'up' | 'down';
};

export function TrendBadge({ delta, goodDirection = 'up' }: TrendBadgeProps) {
  const { t } = useTranslation();
  if (delta === null) return null;

  const Icon = delta > 0 ? MoveUpRight : delta < 0 ? MoveDownRight : MoveRight;
  // Degisim yoksa (0) ne iyi ne kotu — notr ton.
  const meaning = delta === 0 ? 'flat' : (delta > 0) === (goodDirection === 'up') ? 'good' : 'bad';

  return (
    <span className={[styles.badge, styles[meaning]].join(' ')}>
      <Icon size={12} strokeWidth={2.4} aria-hidden="true" />
      <span>%{Math.abs(delta)}</span>
      <span className="visually-hidden">
        {delta > 0
          ? t('trend.increaseVsPrev', { value: Math.abs(delta) })
          : delta < 0
            ? t('trend.decreaseVsPrev', { value: Math.abs(delta) })
            : t('trend.flatVsPrev')}
      </span>
    </span>
  );
}
